export const stockAssets = {
  heroCrowd: '/images/stock/stadium-crowd.jpg',
  solutionsVenue: '/images/stock/stadium-venue.jpg',
  concertVenue: '/images/stock/concert-venue.jpg',
  featuresOrder: '/images/stock/features-order.jpg',
  howItWorksSeat: '/images/stock/how-it-works-seat.jpg',
  technologyKitchen: '/images/stock/technology-kitchen.jpg',
  oniDifference: '/images/stock/oni-difference.png',
} as const;
